import axiosInstance from '../api.service.js';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = "JobSchedule/";

const getJobSchedules = async (jobId) => await axiosInstance.get(ENDPOINTORIGIN + 'GetJobSchedules?jobId=' + jobId, constants.REQUIRE_INTERCEPTORS);

const getConflictedJobSchedules = async (model) => await axiosInstance.get(ENDPOINTORIGIN + 'GetConflictedJobSchedules', model, constants.REQUIRE_INTERCEPTORS);

const saveJobSchedule = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'SaveJobSchedule', model, constants.REQUIRE_INTERCEPTORS);

const moveSchedule = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'MoveSchedule', model, constants.REQUIRE_INTERCEPTORS);

const deleteJobSchedule = async (jobScheduleId) => await axiosInstance.get(ENDPOINTORIGIN + 'DeleteJobSchedule?jobScheduleId=' + jobScheduleId, constants.REQUIRE_INTERCEPTORS);

export {
    getJobSchedules,
    saveJobSchedule,
    getConflictedJobSchedules,
    deleteJobSchedule,
    moveSchedule
}